import { NotificationStatusKeys } from '@/enums/NotificationStatusKeys'
import { formatterArray } from '@/utils/formatterArray'
import { simpleSound } from '@/utils/simpleSound'

// De-duplicate notifications that can legitimately be delivered more than once,
// e.g. an event broadcast received over two realtime connections (a leaked/extra
// Echo), via a stacked channel listener, or re-POSTed when the queued broadcast
// job is redelivered. Callers pass a stable `dedupe_key` (e.g. `broadcast:<id>`);
// repeat deliveries within this window are dropped. The window is generous because
// a redelivered broadcast can arrive well after the first copy.
const DEDUPE_WINDOW_MS = 60000
const recentDedupeKeys = new Map()

export const Notifications = {
  namespaced: true,
  state: {
    count: 0,
    notifications: [],
    notifyModal: false,
    notifyInfo: {},
    notifyModalQueue: [],
  },
  mutations: {
    count(state, payload) {
      state.count = payload
    },
    notifications(state, payload) {
      state.notifications.push({
        id: payload.id,
        title: payload.title,
        body: payload.body,
        type: payload.type ? payload.type : 'simple',
        clickable: payload.clickable,
        status: payload.status,
        action_label: payload.action_label,
        msg_meta:
          payload.type == 'msg'
            ? { ...payload.msg_meta }
            : {
                partner_user: {},
                channel_id: 0,
              },
      })
    },
    notificationsRemove(state, payload) {
      state.notifications = state.notifications.filter((n) => n.id !== payload)
    },
    setNotification(state, obj) {
      Object.keys(obj).forEach((k) => (state[k] = obj[k]))
    },
  },
  getters: {
    notifications(state) {
      return state.notifications
    },
    count(state) {
      return state.count
    },
  },

  actions: {
    addNotification({ commit, state }, payload) {
      const currentId = state.count
      console.log('Notification', { payload })
      const duration = Object.hasOwn(payload, 'duration')
        ? payload.duration
        : 6000
      const status = Object.hasOwn(payload, 'status')
        ? payload.status
        : 'success'
      if (!NotificationStatusKeys[status]) {
        const values = Object.keys(NotificationStatusKeys)
        console.error(
          'Wrong value for the `status` prop.' +
            `Given ${
              payload.status
            }, expected one of: "${formatterArray().format(values)}".`,
        )
        return
      }

      // Drop duplicate deliveries of the same logical notification.
      if (payload.dedupe_key) {
        const now = Date.now()
        const lastSeen = recentDedupeKeys.get(payload.dedupe_key)
        if (lastSeen && now - lastSeen < DEDUPE_WINDOW_MS) {
          return
        }
        recentDedupeKeys.set(payload.dedupe_key, now)
        recentDedupeKeys.forEach((ts, key) => {
          if (now - ts > DEDUPE_WINDOW_MS) {
            recentDedupeKeys.delete(key)
          }
        })
      }

      if (payload.has_sound) {
        simpleSound()
      }
      commit('notifications', { id: currentId, ...payload, status })
      // check if preferences sound on

      if (duration != 0) {
        setTimeout(() => {
          console.log('Removing: ' + currentId)
          commit('notificationsRemove', currentId)
        }, duration)
      }

      // let next;
      commit('count', state.count + 1)
    },
  },
}
